import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { storage } from "../../lib/cliente";
import { useSonho } from "../../services/sonhos";
import { Sonho } from "../../types";
import { memoObserver } from "../../utils/memoObserver.utils";
import { useStores } from "../contexts/store-provider.context";
import { CModal } from "../data-display";
import { FormSonho, FormSonhoRef } from "./form-sonhos.component";

export interface ModalEditSonhoProps {
  id: string;
}

export const ModalEditSonho = memoObserver(({ id }: ModalEditSonhoProps) => {
  const { updateSonho, getSonho, deleteImages } = useSonho();
  const formRef = React.useRef<FormSonhoRef>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { sonhoStore } = useStores();

  const onSubmit = async (values: Sonho) => {
    try {
      const files = formRef?.current?.getFiles();
      const initialFiles = formRef?.current?.getInitialFiles() ?? [];
      const deletedFiles = formRef?.current?.getDeleteFiles() ?? [];

      if (deletedFiles.length > 0) {
        await deleteImages(deletedFiles);
      }

      setLoading(true);
      if (files) {
        const uploadPromises: Promise<string>[] = files.map(
          async (file: any | Blob) => {
            return new Promise<string>((resolve, reject) => {
              if (!file.status) {
                const uniqueFileName = uuidv4() + "-" + file.name;
                const fileRef = ref(storage, `images/${uniqueFileName}`);
                const uploadTask = uploadBytesResumable(fileRef, file);
                uploadTask.on(
                  "state_changed",
                  null,
                  (error) => reject(error),
                  async () => {
                    try {
                      const url = await getDownloadURL(uploadTask.snapshot.ref);
                      resolve(url);
                    } catch (error) {
                      reject(error);
                    }
                  }
                );
              } else {
                resolve(file.url);
              }
            });
          }
        );
        const resolvedUrls = await Promise.all(uploadPromises);

        const newItem = {
          ...values,
          imagesUrl: [...initialFiles, ...resolvedUrls],
        };

        await updateSonho(newItem);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={() => {
          setOpen(true);
          getSonho(id);
        }}
      >
        <EditIcon />
      </IconButton>
      <CModal
        title="Atualizar Pacote"
        onSave={() => {
          formRef.current?.submit();
          handleClose();
        }}
        open={open}
        onClose={() => handleClose()}
        loading={loading}
      >
        <FormSonho
          ref={formRef}
          onSubmit={onSubmit}
          initialValues={sonhoStore.selectedData}
          loading={sonhoStore.crudLoading["edit"]}
        />
      </CModal>
    </>
  );
});
